// Sentry SDK 를 import 하는 유일한 파일. 설정은 sentryOptions 가 만들고 여기서는 init 과 어댑터 생성만 한다.

import { buildSentryOptions, createSentryAdapter } from '@mathflat/shared/@modules/errorReporting'
import * as Sentry from '@sentry/react'

import { envUtils } from '@/utils/envUtils'

export const initSentry = () => {
  Sentry.init(
    buildSentryOptions({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      vercelEnv: import.meta.env.VITE_VERCEL_ENV,
      releaseId: envUtils.releaseId,
      sentryEnabledFlag: import.meta.env.VITE_SENTRY_ENABLED,
    }),
  )
}

export const sentryAdapter = createSentryAdapter(Sentry)
